


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Mixin, Mixins } from 'vue-mixin-decorator'
import LanderMixin from '@/mixins/LanderMixin'; // @ is an alias to /src
import { StoryUser } from '../StoryUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import home001 from '@/homes/home001.vue';             // @ is an alias to /src

@Component({
  name: 'HomeAnonymous',
  components: { 
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
    FBCommentsComponent: () => import('@/components/FBCommentsComponent.vue'),
    LanderStepsComponent: () => import('@/components/LanderStepsComponent.vue'),
    LanderThreeBoxesPanelComponent: () => import('@/components/LanderThreeBoxesPanelComponent.vue'),
    UrgencyAndSignUpButtonComponent: () => import('@/components/UrgencyAndSignUpButtonComponent.vue')
   }
})
export default class HomeAnonymous extends Mixins<LanderMixin>(LanderMixin) {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get imageSource(): string { return `/images/${this.image}` }

  public homeId: string = null
  public homeComponent: typeof home001 = null
  public email: string = null
  
  public userClickedCTA(): void {
    if (this.optimizeForFacebook()) this.userChoseFacebookLogin();
    else this.userChoseRegister()
  }

  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as any).show('Sign Up', 'sm', null)
  }

  public userChoseFacebookLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (window as any).analytics.track('User ClickedFBLogin')
    this.$fb.login()
  }

  // lifecycle
  public created() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} created()`, this.utm_source, this.utm_campaign, this.utm_medium, this.utm_content)

    // choose homepage id
    this.homeId = 'home001'

    switch (this.homeId) {
      case 'home001':
        this.homeComponent = home001;
        break;
    }
    
    if (this.utm_source) this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'

    const images = [
      // 'family-meadow-gradient-1022x537-60.jpg',
      'woman-cellular-phone-1022x537-60.jpg',
      'asian-grandfather-and-grandson-1022x537-60.jpg',
      'asian-santa-grandfather-and-grandson-1022x537-60.jpg',
      'grandma-granddaughter-xmas-1022x537-60.jpg',
      'old-man-hat-gray-1022x537-60.jpg',
      'elderly-couple-close-bw-1022x537-60.jpg'
    ]
    const title = [
      // 'Everyone has a story to tell.',
      // 'Because you have stories to tell.',
      // 'Make your life stories last forever.',
      // 'Imagine your stories lasting forever.',
      // 'Preserve your life stories forever.',
      "Imagine having a loved one's voice forever.",
      "Preserve your loved ones' voices forever."

    ]
    const subtitle = [
      'Use your voice to share life memories with your circle of loved ones. Privately.',
      'Use your voice to share life memories with your private circle of loved ones.'
    ]

    // can choose randomly or choose intelligently based on utm's
    this.image = images[Math.floor(Math.random() * images.length)]
    this.title = title[Math.floor(Math.random() * title.length)]
    this.subtitle = subtitle[Math.floor(Math.random() * subtitle.length)]
    this.signUpText = '3 Easy Steps to Preserve Your Memories',
    this.buttonCTA = 'Sign Up Free →'

    // use utm's to inform us
    // don't use setImageBasedOnUTMContent(), cuz those aren't homepage gradient images
    if (this.utm_content) {
      if (this.utm_content.includes('woman-cellular-phone')) this.image = 'woman-cellular-phone-1022x537-60.jpg'
      if (this.utm_content.includes('asian-grandfather-and-grandson')) this.image = 'asian-grandfather-and-grandson-1022x537-60.jpg';
      if (this.utm_content.includes('grandma-granddaughter-sofa')) this.image = 'grandma-granddaughter-xmas-1022x537-60.jpg';
      if (this.utm_content.includes('asian-santa-grandfather-and-grandson')) this.image = 'asian-santa-grandfather-and-grandson-1022x537-60.jpg';
      if (this.utm_content.includes('old-man-hat-gray')) this.image = 'old-man-hat-gray-1022x537-60.jpg';
      if (this.utm_content.includes('elderly-couple-close-bw')) this.image = 'elderly-couple-close-bw-1022x537-60.jpg';
    }

    // randomly choose if we show pricing
    if (Math.random() < 0.5) this.showPricing = true; else this.showPricing = false;

    // for funnel conversion tracking
    (window as any).analytics.track('HomeAnonymous Viewed', { image: this.image, title: this.title, subtitle: this.subtitle, buttonCTA: this.buttonCTA, showFbComments: this.showFbComments, showFBLogin: this.$fb.useFbLoginRandomAB, showPricing: this.showPricing });
  }

  public mounted() { 
    // if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
    console.log(`${this.$options.name} mounted()`);   // do for all to analyze anonymous page loads

    // @ts-ignore: because segment analytics is loaded in head script
    if (window.analytics.page) window.analytics.page(this.$options.name);   // semi-colon was necessary

  }
  public beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  // private, non-reactive member variables

  // private functions not available directly to HTML template

}
